module.exports = "/src/views/fractions/war/map/map.jpg";